export enum InvoiceStatusEnum {
  NoStatus = 'NO_STATUS',
  Paid = 'PAID', // Betald
  DebtCollection = 'DEBT_COLLECTION', // Inkasso
  Disputed = 'DISPUTED', // Bestriden
  PaymentDeferral = 'PAYMENT_DEFERRAL', // Betalningsanstånd
  InstallmentPlan = 'INSTALLMENT_PLAN', // Avbetalningsplan
  Reminded = 'REMINDED', // Påmind
}
